import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { StudyProgram } from '../study-program';
import { Promotion } from '../promotion';
import { Router } from '@angular/router';
import { CKEDITORCONFIG } from '../ckeditor-config';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-promotion-create',
  templateUrl: './promotion-create.component.html',
  styleUrls: ['./promotion-create.component.css']
})
export class PromotionCreateComponent implements OnInit {

  promotionForm: FormGroup;
  studyPrograms: StudyProgram[] = [];

  display = false;
  defaultStr = "<table border='1' cellpadding='1' cellspacing='0' style='width:500px'>" +
	"<tbody>" +
		"<tr>" +
			"<td>&nbsp;</td>" +
			"<td>&nbsp;</td>" +
			"<td>&nbsp;</td>" +
		"</tr>" +
		"<tr>" +
			"<td>&nbsp;</td>" +
			"<td>&nbsp;</td>" +
			"<td>&nbsp;</td>" +
		"</tr>" +
		"<tr>" +
			"<td>&nbsp;</td>" +
			"<td>&nbsp;</td>" +
			"<td>&nbsp;</td>" +
    "</tr>" +
    "<tr>" +
    "<td>&nbsp;</td>" +
    "<td>&nbsp;</td>" +
    "<td>&nbsp;</td>" +
  "</tr>" +
	"</tbody>" +
"</table>";

  programForm: FormGroup;

  editorConfig: any = CKEDITORCONFIG;

  public Editor = Editor;

  constructor(
    private httpService: HttpService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    this.promotionForm = formBuilder.group({
      from: [null, Validators.required],
      to: [null, Validators.required],
      description: [this.defaultStr, [Validators.minLength(3), Validators.required]],
      studyProgram: [null, Validators.required]
    });

    this.programForm = formBuilder.group({
      name: ["", [Validators.required, Validators.minLength(2)]]
    });
   }

  ngOnInit() {
    this.httpService.getStudyPrograms().subscribe(res => {
      this.studyPrograms = res;
    });
  }

  sendForm(){
    if(this.promotionForm.invalid){
      console.log("promotion form is invalid");
      return;
    }
            // remove zero width space in the comment
    let description = this.promotionForm.value.description.replace(/\u200B/g,"");
    let promotion = new Promotion(
      moment(this.promotionForm.value.from).utc(true),
      moment(this.promotionForm.value.to).utc(true),
      description,
      this.promotionForm.value.studyProgram
    );
    this.httpService.postPromotion(promotion).subscribe(() => {
      this.router.navigateByUrl("/management/promotions");
    });
  }

  sendStudyProgram(){
    if(this.programForm.invalid){
      return;
    }
    let program = new StudyProgram(
      this.programForm.value.name
    );
    this.httpService.postStudyProgram(program)
    .subscribe(program => {
      this.studyPrograms.push(program);
      this.display = false;
      this.programForm.get("name")!.setValue("");
    });
  }

  change(){
    if(this.promotionForm.value.studyProgram == -1){
      this.promotionForm.get("studyProgram")!.setValue(null);
      this.display = true;
    }
  }

  cancelCreate(){
    this.router.navigateByUrl("/management/promotions");
  }

}
